import { get, put } from 'utils/api/api';

import { ClientPaymentMethodInfo } from 'types/client';

import { CLIENT_PAYMENT_METHODS, JOB } from 'constants/endpoints';

class ClientsService {
  async getPaymentMethodsInfo(): Promise<ClientPaymentMethodInfo[]> {
    const response = await get(`${CLIENT_PAYMENT_METHODS}`);
    return response;
  }

  async unsubscribePaidJob(jobId: string): Promise<void> {
    await put(`${JOB}/${jobId}/unsubscribe`, {});
  }

  async subscribePaidJob(jobId: string): Promise<void> {
    await put(`${JOB}/${jobId}/subscribe`, {});
  }

  async retryPaymentForPaidJob(jobId: string): Promise<void> {
    await put(`${JOB}/subscription/${jobId}/pay`, {});
  }
}

export default new ClientsService();
